import type { CategoryFilters } from '~/types/api/data/product/filter/filter.types'

export const filterBySlugUrlThatIsTopCategory =
  () => (category: CategoryFilters) =>
    category.slugUrl.split('/').length === 1 // if length === 1 means is topCategory i.e slugUrl: makeup

export const filterByTopCategoryRouteParam =
  (topCategoryUrl: string) => (category: CategoryFilters) =>
    category.slugUrl === topCategoryUrl

export const filterByParentId =
  (parentId: string) => (category: CategoryFilters) =>
    category.parentId == parentId
